import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "components";
import { getApi, patchApi, postApi } from "lib";
import {
  BUSINESS_PROFESSION,
  CREATE_BUSINESS_DETAILS,
  PRODUCTS,
  PRODUCT_CATEGORY,
  VENDOR_LOGIN,
  VENDOR_SIGNUP,
} from "services";
import { API_ERROR } from "utils/constant";
import { encryptPasswordIfEnabled } from "../../../utils/passwordEncryption";

export const getBusinessProfession = createAsyncThunk(
  "Vendor/getBusinessProfession",
  async (payload, thunkAPI) => {
    try {
      const response = await getApi(`${BUSINESS_PROFESSION}?type=${payload}`);
      if (response?.data?.success) {
        return response?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const postVendorSignUp = createAsyncThunk(
  "Vendor/postVendorSignUp",
  async ({ body, next }, thunkAPI) => {
    try {
      const encryptedPassword = await encryptPasswordIfEnabled(body?.password);
      const requestBody = body?.password
        ? { ...body, password: encryptedPassword }
        : body;

      const response = await postApi(VENDOR_SIGNUP, requestBody);
      if (response?.data?.success) {
        message.success(response?.data?.message);
        next(response);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const postVendorSignIn = createAsyncThunk(
  "Vendor/postVendorSignIn ",
  async ({ body, next }, thunkAPI) => {
    try {
      const encryptedPassword = await encryptPasswordIfEnabled(body?.password);
      const requestBody = body?.password
        ? { ...body, password: encryptedPassword }
        : body;

      const response = await postApi(VENDOR_LOGIN, requestBody);
      if (response?.data?.status === 200) {
        message.success(response?.data?.message);
         localStorage.setItem("auth", JSON.stringify(response?.data));
        next();
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const postBusinessDetails = createAsyncThunk(
  "Vendor/postBusinessDetails",
  async ({ body, next }, thunkAPI) => {
    try {
      const response = await postApi(CREATE_BUSINESS_DETAILS, body);
      if (response?.data?.success) {
        message.success(response?.data?.message);
        next();
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const getProducts = createAsyncThunk(
  "catalogs/getProducts",
  async ({ user, page }, thunkAPI) => {
    try {
      const response = await getApi(
        `${PRODUCTS}?vendor_id=${user || ""}&page=${page || 0}`
      );
      if (response?.data?.success) {
        return response?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const postProduct = createAsyncThunk(
  "catalogs/postProduct",
  async ({ body, next = () => {} }, thunkAPI) => {
    try {
      const response = await postApi(PRODUCTS, body);
      if (response?.data?.success) {
        message.success(response?.data?.message);
        next();
        return response?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const patchProduct = createAsyncThunk(
  "catalogs/patchProduct",
  async ({ body, next = () => {} }, thunkAPI) => {
    try {
      const response = await patchApi(PRODUCTS, body);
      if (response?.data?.success) {
        message.success(response?.data?.message);
        next();
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const getProductCategories = createAsyncThunk(
  "catalogs/getProductCategories",
  async (payload = "", thunkAPI) => {
    try {
      const response = await getApi(PRODUCT_CATEGORY + payload);
      return response?.data?.categories;
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
